import type { OrderItem } from '@/types/order-item-type'

export const CAREER_GUIDE_PRODUCT_TYPE = 'career_guide' as const

export function isCareerGuideOrderItem(item: OrderItem): boolean {
  return item.product.product_type === CAREER_GUIDE_PRODUCT_TYPE
}

/** Itens exibidos no carrinho/checkout — exclui o Guia de Carreiras (liberado só após pagamento). */
export function getCheckoutVisibleItems(
  items: OrderItem[] | null | undefined
): OrderItem[] {
  return (items ?? []).filter(
    item => !item.removed_at && !isCareerGuideOrderItem(item)
  )
}
